export async function loadMarkdown(path: string) {
  const response = await fetch(path);
  return response.text();
}
